import apiClient from '@/utils/apiClient';

const GET_AGENT_PROVISIONED_NUMBER_HISTORY_PATH = '/api/admin/agent-phone-number-history';
const ADMIN_UPDATE_AGENT_PROVISIONED_NUMBER_PATH = '/api/admin/agent-phone-number-update';

export const agentProvisionedNumberHistory = async (
	username: string,
): Promise<{
	success: boolean;
	data?: any;
	message?: string;
}> => {
	const response = await apiClient.request({
		method: 'POST',
		endPoint: GET_AGENT_PROVISIONED_NUMBER_HISTORY_PATH,
		body: {
			username,
		},
		clientType: 'ADMIN',
	});

	return response;
};

export const updateAgentProvisionedNumberAdmin = async (reqObj: {
	number: string;
	phone: string;
	updateReason: string;
	userId: string;
	countryCode: string;
}): Promise<{
	success: boolean;
	message?: string;
}> => {
	const response = await apiClient.request({
		method: 'POST',
		endPoint: ADMIN_UPDATE_AGENT_PROVISIONED_NUMBER_PATH,
		body: reqObj,
		clientType: 'ADMIN',
	});

	return response;
};
